import useTimeZoneClock from 'hooks/useTimeZoneClock';
import { getBackgroundStyle } from 'components/common/TableColor';
import moment from 'moment';
import React from 'react'
import { SubmitButton } from './common/buttons/SubmitButton';

const AppointmentDetailsTable = ({ item }) => {
  const timeZone = useTimeZoneClock(item?.datetime);
    const formattedDate = moment(timeZone).format('MMMM DD YYYY');
    const formattedTime = moment(timeZone).format('hh:mm A');
    
    const InfoRow = ({ label, value, toLowerCase = "" }) => (
        <div className='row_detail_tab'>
            <div className='label_view'><strong>{label}</strong></div>
            <div className={`detail_view ${toLowerCase}`}>{value || 'N/A'}</div>
        </div>
    );
    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash3Style = {
        marginTop: 0,
    };
    const marginTopZero = {
        marginTop: 0
    };

    console.log("item", item)

    const fields = [
        { label: "US Based Vendor", name: "us_based", isLocked: 0 },
        { label: "Non US Based Vendor", name: "non_us_based", isLocked: 0 },
        { label: "English To Target Language", name: "english_to_target", isLocked: 0 },
        { label: "Spanish To Target Language", name: "spanish_to_target", isLocked: 0 },
        { label: "Court Certified", name: "court_certified", isLocked: 0 },
        { label: "Medical Certified", name: "medical_certified", isLocked: 0 },
    ];


    const dynamicFields = React.useMemo(() => {
        const dynamic_fields = item?.appointment_details?.dynamic_fields && JSON.parse(item?.appointment_details?.dynamic_fields) || []
        const dynamicFields = dynamic_fields?.map(field => ({ name: field?.name, value: field?.value }));
        return dynamicFields || [];
    }, [item?.appointment_details?.dynamic_fields])

    const renderTableItem = (title, text) => (
        <>
            <td className='bg-primary-secondary'>
                <h4>{title}</h4>
            </td>
            <td className='bg-primary-secondary'>{text || 'N/A'}</td>
        </>

    )

    
  return (
     <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
               <div className="row_dash_1" style={rowDash1Style}>
                   <div className="card_table" style={marginTopZero}>
                     
                       <div className="Table_data_show Table_data_show1 pt-0">
                       <table class="bg-primary-secondary table">
                           <tbody>
                               <tr>
                                   <td class="bg-primary-secondary" style={{ width: "40%" }}>Facility: </td>
                                   <td class="bg-primary-secondary">{item?.appointment_details?.facility?.facility_name || item?.appointment_details?.facility?.abbreviation || 'N/A'}</td>
                               </tr>
                               <tr>
                                   <td class="bg-primary-secondary" style={{ width: "40%" }}>Department: </td>
                                   <td class="bg-primary-secondary">{item?.appointment_details?.department?.department_name || 'N/A'}</td>
                               </tr>
                               {item?.type === 'In Person' && (
                               <tr>
                                   <td class="bg-primary-secondary" style={{ width: "40%" }}>Address:</td>
                                   <td class="bg-primary-secondary">{item?.appointment_details?.address || item?.appointment_details?.facility?.street_address || item?.appointment_details?.facility?.address || 'N/A'}</td>
                               </tr>
                               )}
                           </tbody>
                       </table>
                       </div>
                       <div className="interpreter p-4">
                           <h2>Vendor</h2>
                       </div>
                       <div className="Table_data_show Table_data_show1 pt-0 mt-2" style={rowDash3Style}>
                           <table class="bg-primary-secondary table">
                               <tbody>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Vendor Name: </td>
                                       <td className="bg-primary-secondary">
                                           {item?.interpreter?.vendor
                                           ? item?.interpreter?.user?.name + ' - ' + item?.interpreter?.vendor?.name
                                           : item?.interpreter?.user?.name  || 'N/A'}
                                       </td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Vendor Email: </td>
                                       <td class="bg-primary-secondary">{item?.interpreter?.user?.email  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Vendor Phone: </td>
                                       <td class="bg-primary-secondary">{item?.interpreter?.phone  || 'N/A'}</td>
                                   </tr>
                                    
                                    <tr>
                                        <td class="bg-primary-secondary">Checkin Date:</td>
                                        <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_date || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary">Checkin Time:</td>
                                        <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_time || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary">Checkout Date:</td>
                                        <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_date || 'N/A'}</td>

                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary">Checkout Time:</td>
                                        <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_time || 'N/A'}</td>
                                    </tr>
                               </tbody>
                           </table>
                       </div>
                       {/* <div className="Table_data_show Table_data_show2 pt-0">
                           <table class="bg-primary-secondary table">
                               <tbody>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Provider Name: </td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.provider_name || 'N/A'}</td>
                                   </tr>
                               </tbody>
                           </table>
                       </div> */}
                       
                   </div>
                   
                   <div className="card_table" style={marginTopZero}>
                           
                       <div className="Table_data_show Table_data_show1 pt-0 ">
                           <table class="bg-info-secondary table" style={getBackgroundStyle(item?.status)}>
                               <tbody>
                                   <tr>
                                   <td className="bg-info-secondary" style={{ ...getBackgroundStyle(item?.status), width: "40%" }}>Status: </td>
                                       <td className="bg-info-secondary capitalize-status" style={getBackgroundStyle(item?.status)}>{item?.status}</td>
                                   </tr>
                               </tbody>
                           </table>
                       </div>

                       <div className="Table_data_show Table_data_show1 pt-0">
                            <table className="bg-primary-secondary table">
                                <tbody>
                                    {fields.map((field, index) => (
                                        <tr key={index}>
                                            <td className="bg-primary-secondary" style={{ width: "40%" }}>
                                                {field.label}
                                            </td>
                                            <td className="bg-primary-secondary">
                                                {item?.appointment_details?.[field.name] === 1
                                                    ? "Yes"
                                                    : item?.appointment_details?.[field.name] === 0
                                                        ? "No"
                                                        : "N/A"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                       <div className="Table_data_show Table_data_show1 pt-0 ">
                           <table class="bg-primary-secondary table">
                               <tbody>
                                {/* <tr>
                                     <td class="bg-primary-secondary">Priority Level:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.priority_level || 'N/A'}</td>
                                </tr>
                                <tr>
                                      <td class="bg-primary-secondary">Special Instructions:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.special_instruction || 'N/A'}</td>
                                </tr> */}
                                {/* <tr>
                                    <td class="bg-primary-secondary">DNC Reason:</td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.dnc_reason || 'N/A'}</td>  
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">CNC Reason:</td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.cnc_reason || 'N/A'}</td>
                                </tr> */}
                                   {/* <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Patient Name: </td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.patient_name  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>MRN:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.mrn_number  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>DOB:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.birth_date  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Medicaid ID:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_id  || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Health Plan:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_plan  || 'N/A'}</td>
                                   </tr> */}
                               </tbody>
                           </table>
                       </div>
                       <div className="Table_data_show Table_data_show1 pt-0 ">
                           <table class="bg-primary-secondary table">
                               <tbody>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Name: </td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.requester_name || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Email: </td>
                                       <td class="bg-primary-secondary" toLowerCase={'text-lowercase'}>{item.appointment_details?.requester_email || 'N/A'}</td>
                                   </tr>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Phone:</td>
                                       <td class="bg-primary-secondary">{item.appointment_details?.requester_phone || 'N/A'}</td>
                                   </tr>
                               </tbody>
                           </table>
                       </div>
                   </div>
               </div>
               {/* <div className="row_dash_1" style={rowDash2Style}>
                   <div className="Table_data_show Table_data_show1 pt-0 ">
                           <table class="bg-primary-secondary table">
                           <tbody>
                                   <tr>
                                       <td class="bg-primary-secondary" style={{ width: "20%" }}>Estimated Duration: </td>
                                       <td class="bg-primary-secondary" >{`${item?.estimated_duration} minutes`}</td>
                                   
                                       <td class="bg-primary-secondary">Rescheduled Reason: </td>
                                       <td class="bg-primary-secondary">{item?.appointment_details?.reschedule_reason || 'N/A'}</td>
                                   </tr>

                                   <tr>                                   
                                       <td class="bg-primary-secondary" colSpan={2}>Cancel reason: </td>
                                       <td class="bg-primary-secondary" colSpan={2}>{item?.appointment_details?.cancel_reason || 'N/A'}</td>
                                   </tr>
                                </tbody>
                           </table>
                   </div>
               </div> */}

               <div className="row_dash_1" style={rowDash2Style}>
                    <div className="Table_data_show Table_data_show1 pt-0 card_table">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "20%" }}>Estimated Duration: </td>
                                    <td class="bg-primary-secondary" >{item?.estimated_duration || 'N/A'} {item?.estimated_duration_unit || 'N/A'} </td>
                                    <td class="bg-primary-secondary">Rescheduled Reason: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.reschedule_reason || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">Cancel reason: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.cancel_reason || 'N/A'}</td>
                                    <td class="bg-primary-secondary">Notes:</td>
                                    <td class="bg-primary-secondary">{item.appointment_assign?.notes || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">DNC Reason:</td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.dnc_reason || 'N/A'}</td>
                                    <td class="bg-primary-secondary">CNC Reason:</td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.cnc_reason || 'N/A'}</td>
                                </tr>

                                {item?.appointment_details?.admin_notes &&
                                <tr>
                                    <td class="bg-primary-secondary" colSpan={2}>Appointment Notes:</td>
                                    <td class="bg-primary-secondary" colSpan={2}>{item?.appointment_details?.admin_notes || 'N/A'}</td>
                                </tr>
                                }

                                {item?.status === "completed" && (
                                    <>
                                    <tr>
                                        <td className="bg-primary-secondary">Feedback Rating:</td>
                                        <td className="bg-primary-secondary">{item.feedback?.rating ?item.feedback?.rating + ' Star' : 'N/A'}</td>
                                        <td className="bg-primary-secondary">Feedback Comment:</td>
                                        <td className="bg-primary-secondary">
                                            {item.feedback?.comments ?? 'N/A'}
                                        </td>
                                    </tr>
                                    
                                    <tr>
                                        <td className="bg-primary-secondary">Feedback Suggestion:</td>
                                        <td className="bg-primary-secondary" colSpan={3}>
                                            {item.feedback?.suggestions ?? 'N/A'}
                                        </td>
                                    </tr>
                                    </>
                                )}

                            </tbody>
                        </table>
                    </div>
                </div>


                { ( dynamicFields.length > 0 && dynamicFields[0]?.name !== null)  &&    
                    <div className="row_dash_1" style={rowDash2Style}>
                        <div className="Table_data_show Table_data_show1 pt-0">

                            <table className="bg-primary-secondary table">
                                {item?.id &&
                                    <tbody>
                                        <tr >
                                            {dynamicFields.length > 0 && dynamicFields.map((field, index) => (
                                                 renderTableItem(`Dynamic Field ${index + 1}`, `${field.name}: ${field.value || 'N/A' }`)
                                            ))}
                                        </tr>
                                    </tbody>
                                }
                            </table>
                        </div>
                    </div>
                } 

                {item?.type !== "OPI Pre Scheduled" && item?.appointment_interpreter_work_order && (
                    <>
                        <div className="interpreter p-4">
                            <h2>Custom Work Order Details</h2>
                        </div>

                        <div className="row_dash_1" style={rowDash2Style}>
                            <div className="Table_data_show Table_data_show1 pt-0 card_table" style={rowDash3Style}>
                                <table className="bg-primary-secondary table">
                                    <tbody>
                                        <tr>
                                            <td className="bg-primary-secondary">Mileage (km):</td>
                                            <td className="bg-primary-secondary">{item.appointment_interpreter_work_order?.mileage ?? '0'}</td>
                                            <td className="bg-primary-secondary">Mileage Rate:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_interpreter_work_order?.mileage_rate ?? 0).toFixed(2)}
                                            </td>
                                            <td className="bg-primary-secondary">Mileage Total:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_interpreter_work_order?.mileage_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary">Travel Hours:</td>
                                            <td className="bg-primary-secondary">{item.appointment_interpreter_work_order?.travel_hours ?? '0'}</td>
                                            <td className="bg-primary-secondary">Travel Rate:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_interpreter_work_order?.travel_rate ?? 0).toFixed(2)}
                                            </td>
                                            <td className="bg-primary-secondary">Travel Total:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_interpreter_work_order?.travel_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary">Min Duration (hrs):</td>
                                            <td className="bg-primary-secondary">{item.appointment_interpreter_work_order?.min_duration ?? '0'}</td>
                                            <td className="bg-primary-secondary">Rate per hr:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_interpreter_work_order?.duration_rate ?? 0).toFixed(2)}
                                            </td>
                                            <td className="bg-primary-secondary">Session Total:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_interpreter_work_order?.session_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        
                                        
                                        <tr>
                                            <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_interpreter_work_order?.total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </>
                )}
              
           </div>
  );
};

export default AppointmentDetailsTable;





